import { takeEvery, put, call, fork } from 'redux-saga/effects';
// import { v4 as uuidv4 } from 'uuid';

import { Client } from '../../utils/client';
import { HOME_LOAD, homeLoadSuccess } from './actions';
import { setError } from '../../redux-root/actions';

export function* homeLoad(action) {
  // try {

  //   homeData.data.collections = yield call(getAllData, homeData.data.collections);

  //   yield put(homeLoadSuccess(homeData.data, favouriteData));
  // } catch (error) {
  //   console.log(error);

  //   yield put(setError('General Errors', `It's not you. It's us. We are working to fix this...`, error));
  // }
}

function* watchHomeLoad() {
  yield takeEvery(HOME_LOAD, homeLoad);
}

export function* homeSaga() {
  yield fork(watchHomeLoad);
}
